import { Box, Card, CardBody, SimpleGrid, Stat, StatLabel, StatNumber, Text } from '@chakra-ui/react'
import type { DashboardStat } from './types'

type DashboardOverviewSectionProps = {
  stats: DashboardStat[]
  cardBg: string
  subCardBg: string
  subCardBorderColor: string
  subtitleColor: string
  statNumberColor: string
}

export function DashboardOverviewSection(props: DashboardOverviewSectionProps) {
  const {
    stats,
    cardBg,
    subCardBg,
    subCardBorderColor,
    subtitleColor,
    statNumberColor,
  } = props

  return (
    <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={{ base: 4, md: 6 }}>
      {stats.map((stat) => (
        <Card
          key={stat.label}
          bg={cardBg}
          h="full"
          borderRadius="xl"
          boxShadow="sm"
        >
          <CardBody p={{ base: 3, md: 4 }}>
            <Stat>
              <StatLabel
                color={subtitleColor}
                fontSize={{ base: 'xs', md: 'sm' }}
                fontWeight="medium"
                lineHeight="1.4"
                display="-webkit-box"
                sx={{
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                }}
                overflow="hidden"
                minH={{ base: '2.5rem', md: '2.75rem' }}
              >
                {stat.label}
              </StatLabel>
              {stat.items && stat.items.length > 0 ? (
                <SimpleGrid
                  columns={stat.items.length >= 3 ? { base: 3, md: 3 } : { base: 2, md: 2 }}
                  spacing={1.5}
                  mt={2}
                >
                  {stat.items.map((item) => (
                    <Box
                      key={`${stat.label}-${item.label}`}
                      bg={subCardBg}
                      borderWidth="1px"
                      borderColor={subCardBorderColor}
                      borderRadius="lg"
                      px={2.5}
                      py={2.5}
                      minH={{ base: '4.25rem', md: '4.75rem' }}
                    >
                      <Text fontSize="xs" color={subtitleColor} lineHeight="1.2">
                        {item.label}
                      </Text>
                      <Text
                        mt={1}
                        fontSize={{ base: 'sm', md: 'md' }}
                        fontWeight="bold"
                        color={statNumberColor}
                        lineHeight="1.1"
                      >
                        {item.value}
                      </Text>
                    </Box>
                  ))}
                </SimpleGrid>
              ) : (
                <StatNumber
                  fontSize={{ base: 'md', md: 'lg' }}
                  fontWeight="bold"
                  color={statNumberColor}
                  mt={{ base: 7, md: 8 }}
                >
                  {stat.value}
                </StatNumber>
              )}
            </Stat>
          </CardBody>
        </Card>
      ))}
    </SimpleGrid>
  )
}
